import { render, staticRenderFns } from "./EventInfoNotification.vue?vue&type=template&id=ce360e66&scoped=true&"
import script from "./EventInfoNotification.vue?vue&type=script&lang=ts&"
export * from "./EventInfoNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce360e66",
  null
  
)

export default component.exports